import { PAGE_DIMENSIONS } from './types';

export const SELECTED_WIDTH = PAGE_DIMENSIONS.LETTER_WIDTH_MM;
export const SELECTED_HEIGHT = PAGE_DIMENSIONS.LETTER_HEIGHT_MM; 